import auth from '@/api/auth'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('user') || null
  },
  getters: {
    isAuth: state => !!state.user,
    user: (state) => state.user ? JSON.parse(state.user) : null,
    hasRole: (state, getters) => (role) => {
      return getters.user.roles?.some(item => item?.name === role)
    },
    hasPermission: (state, getters) => (permission) => {
      if (getters.hasRole('super-admin')) {
        return true
      }
      return getters.user?.roles?.some(role => {
        return role.permissions?.some(item => item?.name === permission)
      })
    }
  },
  mutations: {
    SET_USER (state, user) {
      state.user = JSON.stringify(user)
      localStorage.setItem('user', state.user)
    },
    CLEAR_USER (state) {
      state.user = null
      localStorage.removeItem('user')
    }
  },
  actions: {
    async login ({ commit, dispatch }, credentials) {
      await auth.csrf()
      const { data: { data } } = await auth.login(credentials)
      commit('SET_USER', data)
      await router.push({ name: 'home' })
    },
    async check ({ commit }) {
      const { data: { data } } = await auth.check()
      commit('SET_USER', data)
    },
    async logout ({ commit }) {
      await auth.logout()
      commit('CLEAR_USER')
      await router.push({ name: 'login' })
    }
  }
}
